import React from 'react';

export const GoldMedalIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4027_6285)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.04192 1.87081C7.20134 1.05727 8.58395 0.622129 10.0003 0.625014C11.4167 0.622129 12.7993 1.05727 13.9587 1.87081C15.1181 2.68435 15.9976 3.83649 16.4767 5.16937C16.9558 6.50225 17.011 7.95067 16.6348 9.31616C16.2586 10.6817 15.4694 11.8974 14.3753 12.7969V18.75C14.3753 18.9158 14.3095 19.0747 14.1923 19.192C14.075 19.3092 13.9161 19.375 13.7503 19.375C13.6534 19.373 13.5578 19.3517 13.4691 19.3125L10.0003 17.5703L6.53157 19.3125C6.43579 19.3598 6.32949 19.3818 6.22281 19.3763C6.11613 19.3708 6.01263 19.3381 5.92219 19.2813C5.83102 19.2259 5.75576 19.1479 5.70373 19.0548C5.6517 18.9617 5.62468 18.8567 5.62532 18.75V12.7969C4.53122 11.8974 3.742 10.6817 3.3658 9.31616C2.9896 7.95067 3.04483 6.50225 3.52392 5.16937C4.003 3.83649 4.8825 2.68435 6.04192 1.87081ZM6.87524 12.177C7.80026 12.7951 8.8878 13.125 10.0003 13.125C11.4915 13.1229 12.9211 12.5297 13.9755 11.4752C15.03 10.4208 15.6233 8.99122 15.6253 7.50001C15.6253 6.38749 15.2954 5.29996 14.6773 4.37493C14.0593 3.44991 13.1807 2.72893 12.1529 2.30319C11.1251 1.87745 9.99408 1.76606 8.90294 1.9831C7.81179 2.20014 6.80951 2.73587 6.02284 3.52254C5.23617 4.30921 4.70044 5.31149 4.4834 6.40263C4.26636 7.49377 4.37775 8.62477 4.8035 9.65261C5.22924 10.6804 5.95021 11.5589 6.87524 12.177ZM14.3752 7.5C14.3752 9.91625 12.4165 11.875 10.0002 11.875C7.584 11.875 5.62524 9.91625 5.62524 7.5C5.62524 5.08375 7.584 3.125 10.0002 3.125C12.4165 3.125 14.3752 5.08375 14.3752 7.5Z"
        fill="url(#paint0_linear_4027_6285)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4027_6285"
        x1="10.0003"
        y1="0.625"
        x2="10.0003"
        y2="19.3771"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1B33B" />
        <stop offset="1" stopColor="#BA7F0D" />
      </linearGradient>
      <clipPath id="clip0_4027_6285">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SilverMedalIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4027_6290)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.04144 1.87081C7.20085 1.05727 8.58347 0.622129 9.99983 0.625014C11.4162 0.622129 12.7988 1.05727 13.9582 1.87081C15.1176 2.68435 15.9971 3.83649 16.4762 5.16937C16.9553 6.50225 17.0105 7.95067 16.6343 9.31616C16.2582 10.6817 15.4689 11.8974 14.3748 12.7969V18.75C14.3748 18.9158 14.309 19.0747 14.1918 19.192C14.0746 19.3092 13.9156 19.375 13.7498 19.375C13.6529 19.373 13.5573 19.3517 13.4686 19.3125L9.99983 17.5703L6.53108 19.3125C6.4353 19.3598 6.329 19.3818 6.22232 19.3763C6.11564 19.3708 6.01214 19.3381 5.92171 19.2813C5.83054 19.2259 5.75527 19.1479 5.70324 19.0548C5.65121 18.9617 5.62419 18.8567 5.62483 18.75V12.7969C4.53073 11.8974 3.74151 10.6817 3.36531 9.31616C2.98912 7.95067 3.04434 6.50225 3.52343 5.16937C4.00251 3.83649 4.88202 2.68435 6.04144 1.87081ZM6.87475 12.177C7.79977 12.7951 8.88731 13.125 9.99983 13.125C11.491 13.1229 12.9206 12.5297 13.975 11.4752C15.0295 10.4208 15.6228 8.99122 15.6248 7.50001C15.6248 6.38749 15.2949 5.29996 14.6768 4.37493C14.0588 3.44991 13.1803 2.72893 12.1524 2.30319C11.1246 1.87745 9.99359 1.76606 8.90245 1.9831C7.8113 2.20014 6.80903 2.73587 6.02235 3.52254C5.23568 4.30921 4.69996 5.31149 4.48291 6.40263C4.26587 7.49377 4.37727 8.62477 4.80301 9.65261C5.22875 10.6804 5.94972 11.5589 6.87475 12.177ZM14.3749 7.5C14.3749 9.91625 12.4161 11.875 9.99988 11.875C7.58363 11.875 5.62488 9.91625 5.62488 7.5C5.62488 5.08375 7.58363 3.125 9.99988 3.125C12.4161 3.125 14.3749 5.08375 14.3749 7.5Z"
        fill="url(#paint0_linear_4027_6290)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4027_6290"
        x1="9.99983"
        y1="0.625"
        x2="9.99983"
        y2="19.3771"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B0B0B0" />
        <stop offset="1" stopColor="#7D7D7D" />
      </linearGradient>
      <clipPath id="clip0_4027_6290">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BronzeMedalIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_4027_6295)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.04144 1.87081C7.20085 1.05727 8.58347 0.622129 9.99983 0.625014C11.4162 0.622129 12.7988 1.05727 13.9582 1.87081C15.1176 2.68435 15.9971 3.83649 16.4762 5.16937C16.9553 6.50225 17.0105 7.95067 16.6343 9.31616C16.2582 10.6817 15.4689 11.8974 14.3748 12.7969V18.75C14.3748 18.9158 14.309 19.0747 14.1918 19.192C14.0746 19.3092 13.9156 19.375 13.7498 19.375C13.6529 19.373 13.5573 19.3517 13.4686 19.3125L9.99983 17.5703L6.53108 19.3125C6.4353 19.3598 6.329 19.3818 6.22232 19.3763C6.11564 19.3708 6.01214 19.3381 5.92171 19.2813C5.83054 19.2259 5.75527 19.1479 5.70324 19.0548C5.65121 18.9617 5.62419 18.8567 5.62483 18.75V12.7969C4.53073 11.8974 3.74151 10.6817 3.36531 9.31616C2.98912 7.95067 3.04434 6.50225 3.52343 5.16937C4.00251 3.83649 4.88202 2.68435 6.04144 1.87081ZM6.87475 12.177C7.79977 12.7951 8.88731 13.125 9.99983 13.125C11.491 13.1229 12.9206 12.5297 13.975 11.4752C15.0295 10.4208 15.6228 8.99122 15.6248 7.50001C15.6248 6.38749 15.2949 5.29996 14.6768 4.37493C14.0588 3.44991 13.1803 2.72893 12.1524 2.30319C11.1246 1.87745 9.99359 1.76606 8.90245 1.9831C7.8113 2.20014 6.80903 2.73587 6.02235 3.52254C5.23568 4.30921 4.69996 5.31149 4.48291 6.40263C4.26587 7.49377 4.37727 8.62477 4.80301 9.65261C5.22875 10.6804 5.94972 11.5589 6.87475 12.177ZM14.3749 7.5C14.3749 9.91625 12.4161 11.875 9.99988 11.875C7.58363 11.875 5.62488 9.91625 5.62488 7.5C5.62488 5.08375 7.58363 3.125 9.99988 3.125C12.4161 3.125 14.3749 5.08375 14.3749 7.5Z"
        fill="url(#paint0_linear_4027_6295)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4027_6295"
        x1="9.99983"
        y1="0.625"
        x2="9.99983"
        y2="19.3771"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C86128" />
        <stop offset="1" stopColor="#733817" />
      </linearGradient>
      <clipPath id="clip0_4027_6295">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
